 import React from 'react'

    function Inicio() {
      return (
      <div id="inicio" className="text-center" style={{ backgroundColor: '#0c2943', color:'#fff'}}>{/*#6372ff 0%, #5ca9fb*/}
      <div className="container">
        <div className="section-title">
          <h1>Somos gente de acción</h1>
          <p>Nuestra red mundial de 1,4 millones de vecinos, amigos y líderes voluntarios ofrecen sus conocimientos y recursos para resolver problemas y abordar las necesidades de las comunidades.</p>
        </div>
        </div>
        </div>
      )
    }

    export default Inicio